var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[(false)?_c('div',{staticClass:"left"},[_c('search')],1):_vm._e(),_c('div',{staticClass:"right"},[_c('right-header')],1),_c('live-update-controller',{attrs:{"channel":"call-logs"},on:{"signal":_vm.getCallLogs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }